"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _simpleDataReducer = require("../../../common/utils/simpleDataReducer");
var actions = _interopRequireWildcard(require("./actions"));
var _const = require("./const");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const homeReducer = (0, _simpleDataReducer.createReducer)(actions.GET_BANNERS_API);
const homeRxPreorder = (0, _simpleDataReducer.createReducer)(actions.GET_RX_PRE_ORDER_API);
const homeTopReducer = (0, _simpleDataReducer.createReducer)(actions.GET_BANNERS_TOP_API);
const homeMiddleReducer = (0, _simpleDataReducer.createReducer)(actions.GET_BANNERS_MIDDLE_API);
const homeBottomReducer = (0, _simpleDataReducer.createReducer)(actions.GET_BANNERS_BOTTOM_API);
const homeQuickBookingReducer = (0, _simpleDataReducer.createReducer)(actions.GET_BANNERS_QUICK_BOOKING);
const homeOrderAppointmentReducer = (0, _simpleDataReducer.createReducer)(actions.GET_ORDER_APPOINTMENT_CARD_API);
const homeWebReducer = (0, _simpleDataReducer.createReducer)(actions.GET_BANNERS_WEB_API);
const homeScreenBannerReducer = (0, _simpleDataReducer.createReducer)(actions.GET_HOME_SCREEN_BANNER);
const homeScreenPharmacyBannerReducer = (0, _simpleDataReducer.createReducer)(actions.GET_PHARMACY_HOME_SCREEN_BANNER_API);
var _default = exports.default = {
  [_const.GET_BANNERS]: homeReducer,
  [_const.GET_RX_PRE_ORDER]: homeRxPreorder,
  [_const.GET_BANNERS_TOP]: homeTopReducer,
  [_const.GET_BANNERS_MIDDLE]: homeMiddleReducer,
  [_const.GET_BANNERS_BOTTOM]: homeBottomReducer,
  [_const.GET_BANNERS_QUICK_BOOKING]: homeQuickBookingReducer,
  [_const.GET_ORDER_APPOINTMENT_CARD]: homeOrderAppointmentReducer,
  [_const.GET_BANNERS_WEB]: homeWebReducer,
  [_const.GET_HOME_SCREEN_BANNER]: homeScreenBannerReducer,
  [_const.GET_PHARMACY_HOME_SCREEN_BANNER]: homeScreenPharmacyBannerReducer
};